import { PortalRequestedDocs } from "@/features/portal/components/documents/portal-requested-docs";

/** `/portal/requested-documents` — documents the firm requested from the client. */
export default function RequestedDocsPage() {
  return <PortalRequestedDocs />;
}
